<!-- 教育局-资金管理 -->
<template>
  <div>
    <div class="index" v-if="!detail.show && !addShow && !employeesShow">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>
      <div>
        <el-form :model="queryParams" inline>
          <!-- <el-form-item label="机构状态">
            <el-select
              v-model="queryParams.value4"
              clearable
              filterable
              placeholder="请选择"
            >
              <el-option
                v-for="item in optionList4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机构名称">
            <el-col :span="5">
              <el-input placeholder="请输入" v-model="queryParams.org_name">
              </el-input>
            </el-col>
            <el-col :span="2" style="margin-left: 55%">
              <el-form-item label="" label-width="100px">
                <el-button type="primary" size="small" @click="searchFun()"
                  >查询</el-button
                >
              </el-form-item>
            </el-col>
          </el-form-item> -->
          <!-- <el-form-item label="培训形式">
             <div class="select_list">
                <div :class="{select_item:true, on:item.value==on1}" v-for="(item,key) in selectList1" :key="key" @click="selectClick('1',item)">
                     {{item.label}}
                </div>
             </div>
          </el-form-item>
           <el-form-item label="培训类型">
             <el-col :span="5">
              <el-form-item label="" >
                  <el-select style="margin-left: 14px" v-model="queryParams.value1" clearable filterable placeholder="请选择">
                    <el-option
                      v-for="item in optionList1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="培训学段" label-width="100px">
                 <el-select v-model="queryParams.value2" clearable filterable placeholder="请选择">
                    <el-option
                      v-for="item in optionList2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item label="机构类型">
             <el-col :span="5">
              <el-form-item label="" >
                  <el-select style="margin-left: 14px" v-model="queryParams.value3" clearable filterable placeholder="请选择">
                    <el-option
                      v-for="item in optionList3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="机构状态" label-width="100px">
                 <el-select v-model="queryParams.value4" clearable filterable placeholder="请选择">
                    <el-option
                      v-for="item in optionList4"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>
            </el-col>
          </el-form-item> -->
          <!-- <el-form-item label="所在区域">
            <el-select
              style="margin-right: 10px"
              v-model="queryParams.address.proviceCode"
              @change="handleProviceChange"
              clearable
              filterable
              placeholder="请选择省"
            >
              <el-option
                v-for="item in proviceList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              style="margin-right: 10px"
              v-model="queryParams.address.cityCode"
              @change="handleCityChange"
              clearable
              filterable
              placeholder="请选择市"
            >
              <el-option
                v-for="item in cityList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="queryParams.address.areaCode"
              @change="handleAreaChange"
              clearable
              filterable
              placeholder="请选择区"
            >
              <el-option
                v-for="item in areaList"
                :key="item.area_code"
                :label="item.area_name"
                :value="item.area_code"
              >
              </el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="是否纳入监管" label-width="100px">
             <div class="select_list">
                <div :class="{select_item:true, on:item.value==on2}" v-for="(item,key) in selectList2" :key="key" @click="selectClick('2',item)">
                     {{item.label}}
                </div>
             </div>
          </el-form-item>
          <el-form-item label="一课一消服务" label-width="100px">
             <div class="select_list">
                <div :class="{select_item:true, on:item.value==on3}" v-for="(item,key) in selectList3" :key="key" @click="selectClick('3',item)">
                     {{item.label}}
                </div>
             </div>
          </el-form-item>
          <el-form-item label="合同范本" >
             <div class="select_list">
                <div :class="{select_item:true, on:item.value==on4}" v-for="(item,key) in selectList4" :key="key" @click="selectClick('4',item)">
                     {{item.label}}
                </div>
             </div>
          </el-form-item> -->
        </el-form>
        <!-- 待审核 -->
        <div class="table">
          <el-table :data="tableData" style="width: 100%" tooltip-effect="dark">
            <el-table-column
              prop="a"
              label="机构名称"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column prop="b" v-if="!educationType" label="所属区域" show-overflow-tooltip align="center">
            </el-table-column> -->
            <el-table-column
              prop="c"
              label="基本户余额(元)"
              show-overflow-tooltip
              align="center"
            ></el-table-column>
            <el-table-column
              prop="d"
              label="保证金余额(元)"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="e"
              label="保证金备案金额(元)"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="f"
              label="专用户余额(元)"
              show-overflow-tooltip
              width="120px"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="g"
              label="机构状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <!-- <el-table-column  header-align="center" width="70" label="操作" align="center">
                  <template slot-scope="scope">
                            <el-button type="text" size="small" @click="toDetail(scope.row)">查看</el-button>
                  </template>
            </el-table-column> -->
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              :current-page="page.pageNum"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="page.pageSize"
              :total="page.totalPage"
              layout="total,prev, pager, next,jumper,sizes"
              @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getOrgList,
  getNextAreaInfo,
  createOrg,
  getQYInfo,
  getOrgQYList,
} from "@/api/user/userCenter";
export default {
  components: {},
  data() {
    return {
      educationType: sessionStorage.getItem("educationType") === "area",
      selectList1: [
        { label: "线上", value: "1" },
        { label: "线下", value: "2" },
      ],
      selectList2: [
        { label: "未纳入", value: "1" },
        { label: "保证金", value: "2" },
        { label: "监管账户", value: "3" },
      ],
      selectList3: [
        { label: "已提供", value: "1" },
        { label: "未提供", value: "2" },
      ],
      selectList4: [
        { label: "未使用", value: "1" },
        { label: "已使用", value: "2" },
      ],
      on1: "1",
      on2: "1",
      on3: "1",
      on4: "1",
      optionList1: [
        { label: "全部  ", value: "0" },
        { label: "学科    ", value: "1" },
        { label: "非学科    ", value: "2" },
        { label: "学科+非学科    ", value: "3" },
      ],
      optionList2: [
        { label: "全部  ", value: "0" },
        { label: "学龄前    ", value: "1" },
        { label: "义务教育阶段", value: "2" },
        { label: " 高中阶段 ", value: "3" },
      ],
      optionList3: [
        { label: "全部  ", value: "0" },
        { label: "盈利    ", value: "1" },
        { label: "非盈利", value: "2" },
      ],
      optionList4: [
        { label: "全部  ", value: "0" },
        { label: "已备案    ", value: "1" },
        { label: "转审批", value: "2" },
        { label: " 营业中 ", value: "3" },
        { label: "暂停中    ", value: "4" },
        { label: "将型型", value: "5" },
        { label: " 将关停 ", value: "6" },
        { label: " 已关停 ", value: "7" },
      ],
      queryParams: {
        org_name: "",
        address: {
          proviceCode: "",
          proviceName: "",
          cityCode: "",
          cityName: "",
          areaCode: "",
          areaName: "",
        }, //覆盖区域控件选择的地址(默认值)
        data: "",
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
      },
      proviceList: [], //省列表数据
      cityList: [], //市列表数据
      areaList: [], //区列表数据
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },
      addShow: false,
      employeesShow: false,
      detail: {
        info: {},
        show: false,
      },
      statusList: [
        { id: "0", label: "未激活" },
        { id: "1", label: "正常" },
      ],
      recordStatusList: [
        { id: "0", label: "未备案" },
        { id: "1", label: "已备案" },
      ],
      tableData: [],
      visible: false,
      selectOrgId: "",
    };
  },
  watch: {},
  mounted() {},
  created() {
    this.getDataList();
    this.initData();
  },
  filters: {
    statusFilter(type) {
      const typeMap = {
        0: "未激活   ",
        1: "正常    ",
        2: "注销    ",
        3: "锁定    ",
        4: "安管锁定",
        5: "空间封锁",
      };
      return typeMap[type];
    },
    recordStatusFilter(type) {
      const typeMap = {
        0: "未备案",
        1: "已备案",
      };
      return typeMap[type];
    },
  },
  methods: {
    async initData() {
      // 用户中心获取全部省的数据
      getNextAreaInfo({ area_code: "0" }).then((res) => {
        if (res.code == "000000") {
          this.proviceList = res.result;
        }
      });
      if (this.educationType) {
        this.tableData = [
          {
            a: "智课 ",
            b: "D32434221353224",
            c: "¥7,182.00 ",
            d: "¥30,000.00 ",
            e: " ¥20,000.00 ",
            f: "¥2,617.00  ",
            g: " 未备案",
          },
          {
            a: "欧美思",
            b: "D92817382938182",
            c: "¥8,193.00 ",
            d: "¥50,000.00 ",
            e: "¥20,000.00 ",
            f: " ¥8,277.00  ",
            g: " 未备案",
          },
          {
            a: "第七感官",
            b: "D28173829101022",
            c: "¥8,271.00 ",
            d: "¥30,000.00 ",
            e: "¥20,000.00 ",
            f: " ¥2,172.00  ",
            g: " 已备案 ",
          },
          {
            a: "黑色空间",
            b: "D32434221353224",
            c: "¥2,712.00 ",
            d: "¥35,000.00 ",
            e: " ¥20,000.00 ",
            f: "¥4,827.00  ",
            g: " 已备案 ",
          },
          {
            a: "小鱼",
            b: "D92817382938182",
            c: "¥8,271.00 ",
            d: "¥60,000.00 ",
            e: " ¥20,000.00 ",
            f: "¥3,727.00 ",
            g: " 已备案 ",
          },
          {
            a: "许先望",
            b: "D28173829101022",
            c: "¥2,819.00 ",
            d: "¥55,000.00 ",
            e: " ¥20,000.00 ",
            f: "¥8,271.00  ",
            g: " 已备案 ",
          },
          {
            a: "果力教育",
            b: "D32434221353224",
            c: "¥8,721.00 ",
            d: "¥42,000.00 ",
            e: "¥20,000.00 ",
            f: " ¥3,729.00  ",
            g: " 已备案 ",
          },
          {
            a: "智位科技",
            b: "D92817382938182",
            c: "¥7,281.00 ",
            d: "¥66,000.00 ",
            e: "¥20,000.00 ",
            f: " ¥4,928.00 ",
            g: " 已备案",
          },
          {
            a: "海鸟信息",
            b: "D28173829101022",
            c: "¥8,272.00 ",
            d: "¥50,000.00  ",
            e: "¥20,000.00 ",
            f: " ¥5,738.00 ",
            g: " 已备案",
          },
          {
            a: "博客音乐",
            b: "D32434221353224",
            c: "¥4,721.00 ",
            d: "¥50,000.00  ",
            e: "¥20,000.00 ",
            f: " ¥5,383.00 ",
            g: " 已备案",
          },
        ];
      } else {
        if (sessionStorage.getItem("platformCode") == "460000") {
          this.tableData = [
            {
              a: "葛兰姆艺术培训学校有限公司 ",
              b: " 秀英区 ",
              c: " ¥27,182.00  ",
              d: "¥30,000.00   ",
              e: " ¥20,000.00  ",
              f: "¥26,172.00   ",
              g: " 未备案 ",
            },
            {
              a: "怡墨艺术培训学校有限公司",
              b: " 龙华区 ",
              c: " ¥28,193.00  ",
              d: "¥50,000.00  ",
              e: " ¥20,000.00  ",
              f: "¥82,771.00  ",
              g: " 未备案 ",
            },
            {
              a: "伊顿培训学校有限公司",
              b: " 琼山区",
              c: " ¥38,272.00 ",
              d: "¥50,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥57,382.00  ",
              g: " 已备案",
            },
            {
              a: "新语盟外语培训学校",
              b: " 美兰区",
              c: " ¥84,721.00 ",
              d: "¥50,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥53,832.00  ",
              g: " 已备案",
            },
          ];
        } else {
          this.tableData = [
            {
              a: "葛兰姆艺术培训学校有限公司 ",
              b: " 江汉区 ",
              c: " ¥27,182.00  ",
              d: "¥30,000.00   ",
              e: " ¥20,000.00  ",
              f: "¥26,172.00   ",
              g: " 未备案 ",
            },
            {
              a: "怡墨艺术培训学校有限公司",
              b: " 青山区 ",
              c: " ¥28,193.00  ",
              d: "¥50,000.00  ",
              e: " ¥20,000.00  ",
              f: "¥82,771.00  ",
              g: " 未备案 ",
            },
            {
              a: "艾莎艺术培训学校",
              b: " 江夏区 ",
              c: " ¥38,271.00  ",
              d: "¥30,000.00  ",
              e: " ¥20,000.00 ",
              f: " ¥21,727.00  ",
              g: " 已备案 ",
            },
            {
              a: "永红琴苑培训中心",
              b: " 武昌区 ",
              c: " ¥82,712.00  ",
              d: "¥35,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥48,271.00   ",
              g: " 已备案",
            },
            {
              a: "亮霞培训学校有限公司",
              b: " 江汉区 ",
              c: " ¥38,271.00  ",
              d: "¥60,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥37,271.00  ",
              g: " 已备案 ",
            },
            {
              a: "求实教育培训学校",
              b: " 青山区 ",
              c: " ¥82,819.00  ",
              d: "¥55,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥82,711.00   ",
              g: " 已备案",
            },
            {
              a: "曹敏培训学校有限公司",
              b: " 江夏区 ",
              c: " ¥98,721.00  ",
              d: "¥42,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥37,291.00  ",
              g: " 已备案 ",
            },
            {
              a: "宜智文化艺术培训学校有限公司",
              b: "武昌区 ",
              c: " ¥67,281.00  ",
              d: "¥66,000.00 ",
              e: " ¥20,000.00  ",
              f: " ¥49,281.00   ",
              g: " 已备案 ",
            },
            {
              a: "伊顿培训学校有限公司",
              b: " 武昌区",
              c: " ¥38,272.00 ",
              d: "¥50,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥57,382.00  ",
              g: " 已备案",
            },
            {
              a: "新语盟外语培训学校",
              b: " 洪山区",
              c: " ¥84,721.00 ",
              d: "¥50,000.00 ",
              e: " ¥20,000.00 ",
              f: " ¥53,832.00  ",
              g: " 已备案",
            },
          ];
        }
      }
    },
    selectClick(type, item) {
      if (type == "1") {
        this.on1 = item.value;
      } else if (type == "2") {
        this.on2 = item.value;
      } else if (type == "3") {
        this.on3 = item.value;
      } else if (type == "4") {
        this.on4 = item.value;
      }
    },
    async getDataList() {
      console.log("调用机构列表2");
      let isPlatform =
        JSON.parse(window.sessionStorage.getItem("userInfo"))
          .v_platform_code ===
          JSON.parse(window.sessionStorage.getItem("userInfo")).platform_code ||
        JSON.parse(
          window.sessionStorage.getItem("userInfo")
        ).v_platform_code.includes(",");
      let params = {
        // org_id:sessionStorage.getItem("orgId")||'', //	机构、学校等组织id
        org_name: this.queryParams.org_name, //	机构、学校等组织名称
        org_type: "8", //	组织类型，多个使用英文逗号分隔(1机构，2学校，8企业，9教学工作室，10平台)
        province_code: "", //	所属地理省份
        city_code: "", //	所属地理市
        area_code: "", //	所属地理区
        status: this.queryParams.status, //       	状态,多个使用英文逗号分隔(0:组织未激活,1:正常)
        platform_code: isPlatform ? sessionStorage.getItem("platformCode") : "", //	实体平台编码
        v_platform_code: isPlatform
          ? ""
          : JSON.parse(window.sessionStorage.getItem("userInfo"))
              .v_platform_code, //	虚拟平台编码
        certification: "", //	认证(0:未认证,1:已认证)
        org_category: "2", //	组织的类别(见文档十三.4，每个类型的组织都有自己的类别)
        org_level_code: "", //	行政区划(行政上所属的区域)
        org_parent_id: "", //	上级机构id(查的是直属下级单位)
        org_parent_ids: sessionStorage.getItem("orgid_top") || "", //	附属上级机构id(查的是所有的下级单位，包括跨行政级别的下级单位组织)
        flag: "", //	         标记,多个使用英文逗号分隔,默认正常和演示(0:正常,1:演示,2:测试)
        page: this.page.pageNum, //	查询页单独的对的
        page_size: this.page.pageSize, //	查询条数，默认10，上限10011
        is_more: "1", //	返回更多信息(0:否,1:是)
        org_record_status: this.queryParams.org_record_status, // 教育局备案状态
        more_field: [
          "org_record_status",
          "school_legal_person_name",
          "school_legal_person_code",
          "org_code_certificate",
          "org_address",
          "org_telephone",
          "org_social_credit_code",
          "status",
          "org_source_level",
          "org_resource_id",
        ], //	指定返回的字段名称,传入看示例
        sort: "time", //按时间排序
      };
      var { code, result } = await getOrgList(params);
      if (code === "000000") {
        2;
        // this.tableData = result.lists;
        // this.page.totalPage = result.count;
        this.page.totalPage = this.tableData.length;
      }
      console.log("机构-列表77", result);
    },
    async handleProviceChange(areaCode) {
      var obj = {};
      obj = this.proviceList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.proviceName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.cityList = result;
      }
      this.queryParams.address.cityCode = "";
      this.queryParams.address.cityName = "";
      this.queryParams.address.areaCode = "";
      this.queryParams.address.areaName = "";
    },
    async handleCityChange(areaCode) {
      var obj = {};
      obj = this.cityList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.cityName = obj.area_name;
      const { code, result } = await getNextAreaInfo({ area_code: areaCode });
      if (code == "000000") {
        this.areaList = result;
      }
      this.queryParams.address.areaCode = "";
      this.queryParams.address.areaName = "";
    },
    async handleAreaChange(areaCode) {
      var obj = {};
      obj = this.areaList.find(function (item) {
        return item.area_code === areaCode;
      });
      this.queryParams.address.areaName = obj.area_name;
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    add() {
      this.addShow = true;
    },
    sizeChangeHandle(val) {
      // let that;
      // if(this.tabName==='待审核'){
      // 	that=this.queryParams;
      // }else if(this.tabName==='审核通过'){
      // 	that=this.queryParams_2;
      // }else{
      // 	that=this.queryParams_3;
      // }

      this.page.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.page.pageNum = val;
      this.getDataList();
    },
    toDetail(item) {
      console.log("点击查看机构详情----", item);
      this.detail.info = item;
      this.detail.show = true;
    },
    toIndex() {
      console.log("调用机构列表1");
      this.detail.show = false;
      this.addShow = false;
      this.employeesShow = false;
      this.page.pageNum = 1;
      this.getDataList();
    },
    pass(id) {},
    reject(id) {
      this.selectOrgId = id;
      this.employeesShow = true;
    },
    //  locking (id) {
    // 	let params = {
    //     usession_id: sessionStorage.getItem("usessionid"), //	否	string	学年学期
    //     user_id:userId,
    //     status:'3',//0:未激活, 1:正常, 2:注销, 3:成员锁定, 4:安管锁定,5:空间封锁）
    //   };
    // //   var { code, message } = await setUserStatus(params);
    //   if (code == "000000") {
    //      this.page.pageNum=1
    //      this.getDataList()
    //      this.$message({
    //       type: "success",
    //       message: "操作成功",
    //     });
    //   }else{
    //     this.$message({
    //       type: "error",
    //       message: message,
    //     });
    //   }
    //  },
    tabClick(item) {
      this.tabName = item.name;
    },
  },
};
</script>
<style lang="less" scoped>
.index {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
  .select_list {
    width: 100%;
    margin: 6px 20px;
    display: flex;
    justify-content: left;
    align-items: center;
    .select_item {
      width: 70px;
      height: 26px;
      cursor: pointer;
      color: #000;
      text-align: center;
      line-height: 26px;
      border-radius: 26px;
      margin: 0 8px;
    }
    .on {
      background: #4696ec;
      color: #fff;
    }
  }
  ::v-deep .el-form .el-input__inner {
    width: 170px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }
  // ::v-deep .el-form-item__content{
  //     margin-left: -10px !important;
  // }
  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.confirm {
  .content {
    width: 100%;
    padding: 0 15px 15px;
    text-align: center;
  }
}
</style>
